
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface TypographyProps {
  children: ReactNode;
  className?: string;
}

export function TypographyDisplay({ children, className }: TypographyProps) {
  return (
    <h1 className={cn("text-display font-bold tracking-tight", className)}>
      {children}
    </h1>
  );
}

export function TypographyH1({ children, className }: TypographyProps) {
  return (
    <h1 className={cn("text-h1 font-bold tracking-tight", className)}>
      {children}
    </h1>
  );
}

export function TypographyH2({ children, className }: TypographyProps) {
  return (
    <h2 className={cn("text-h2 font-bold tracking-tight", className)}>
      {children}
    </h2>
  );
}

export function TypographyH3({ children, className }: TypographyProps) {
  return (
    <h3 className={cn("text-h3 font-medium", className)}>
      {children}
    </h3>
  );
}

export function TypographyBody({ children, className }: TypographyProps) {
  return (
    <p className={cn("text-body font-regular", className)}>
      {children}
    </p>
  );
}

export function TypographySmall({ children, className }: TypographyProps) {
  return (
    <p className={cn("text-small font-regular", className)}>
      {children}
    </p>
  );
}

export function TypographyTiny({ children, className }: TypographyProps) {
  return (
    <p className={cn("text-tiny font-regular", className)}>
      {children}
    </p>
  );
}

export function ArticleBody({ children, className }: TypographyProps) {
  return (
    <div className={cn("article-body font-serif text-body space-y-4", className)}>
      {children}
    </div>
  );
}
